import {Component, Inject, ViewEncapsulation} from '@angular/core';
import {FormBuilder, FormGroup} from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

import {locale as polish} from './i18n/pl';
import {FuseTranslationLoaderService} from "../../../../@fuse/services/translation-loader.service";
import {TranslateService} from "@ngx-translate/core";
import {Supplier} from "../../models/supplier";

@Component({
    selector: 'supplier-form-dialog',
    templateUrl: './supplierDialog.component.html',
    styleUrls: ['./supplierDialog.component.scss'],
    encapsulation: ViewEncapsulation.None
})

export class SupplierDialogComponent {
    action: string;
    supplier: Supplier;
    supplierForm: FormGroup;
    dialogTitle: string;

    /**
     * Constructor
     *
     * @param {MatDialogRef<CategoryDialogComponent>} matDialogRef
     * @param _data
     * @param {FormBuilder} _formBuilder
     */
    constructor(
        public matDialogRef: MatDialogRef<SupplierDialogComponent>,
        @Inject(MAT_DIALOG_DATA) private _data: any,
        private _formBuilder: FormBuilder,
        private translationLoader: FuseTranslationLoaderService,
        translate: TranslateService
    ) {
        this.translationLoader.loadTranslations(polish);
        // Set the defaults
        this.action = _data.action;

        if (this.action === 'edit') {
            translate.get('Edit Supplier').subscribe((text: string) => {
                this.dialogTitle = text
            });

            this.supplier = _data.supplier;
        } else {
            translate.get('New supplier').subscribe((text: string) => {
                this.dialogTitle = text
            });
            this.supplier = new Supplier();
        }

        this.supplierForm = this.createSupplierForm();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Create supplier form
     *
     * @returns {FormGroup}
     */
    createSupplierForm(): FormGroup {
        return this._formBuilder.group({
            id: [this.supplier.id],
            name: [this.supplier.name],
            email: [this.supplier.email],
            phone: [this.supplier.phone],
            contactPerson: [this.supplier.contactPerson],
            description: [this.supplier.description],
        });
    }
}
